import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import ForgotPassword from '../components/login/forgotPassword';
import SplashScreen from '../components/splashScreen/SplashScreen';
import LoginForm from '../components/login/loginForm';
import { useFeatureFlagsFromContext } from '../launchdarkly';
import { isTokenExpired } from '../utils/jwt';
import { resolvePostLoginDestination } from '../utils/returnPath';

const Login = () => {
  const flags = useFeatureFlagsFromContext();
  const navigate = useNavigate();
  const oktaSsoAuthEnabled = flags?.oktaSsoAuth || false;

  useEffect(() => {
    // Only check for existing authentication if oktaSsoAuth is enabled
    if (!oktaSsoAuthEnabled) {
      return;
    }

    // Resolve the post-login destination: a saved deep-link return path (if any)
    // takes priority over the showReskin-based default.
    const destination = () =>
      resolvePostLoginDestination({ showReskin: flags.showReskin });

    // Check if user is already authenticated
    const accessToken = localStorage.getItem('access');

    if (accessToken && !isTokenExpired(accessToken)) {
      navigate(destination());
      return;
    }

    // Check for SSO query parameter and authenticate using PA_AUTH cookie
    const urlParams = new URLSearchParams(window.location.search);
    const ssoParam = urlParams.get('sso');

    if (ssoParam === 'true') {
      console.log(
        'SSO parameter detected, using PA_AUTH cookie authentication'
      );

      // The PA_AUTH cookie will be automatically sent with API requests
      // and validated by the Django backend's PAAuthTokenAuthentication
      // PA_BLID cookie indicates we're using SSO
      console.log('SSO authentication configured');

      navigate(destination());
    }
  }, [flags.showReskin, navigate, oktaSsoAuthEnabled]);

  return (
    <Box>
      <Routes>
        <Route
          path=""
          element={
            flags.showReskin ? (
              <SplashScreen contentProps={{ currentView: 'login' }} />
            ) : (
              <LoginForm />
            )
          }
        />
        <Route
          path="resetPass"
          element={
            flags.showReskin ? (
              <SplashScreen contentProps={{ currentView: 'resetPass' }} />
            ) : (
              <ForgotPassword />
            )
          }
        />
      </Routes>
    </Box>
  );
};

export default Login;
